export { default } from './Divider';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Divider/index.js
// module id = 321
// module chunks = 0